export default __webpack_public_path__ + "e6c099e9fbc7b3f5621741735920cdc5.svg";